import { jsx as _jsx } from "react/jsx-runtime";
import { buildSignInRedirect } from '#pplx/frontend/apps/ask/auth/buildSignInRedirect.js';
import { useMarbleEnabled } from '#pplx/frontend/apps/ask/hooks/marble-hooks/useMarbleEnabled.js';
import { RedirectTo } from '#pplx/frontend/apps/ask/spa/redirects.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { validateUuid } from '#pplx/frontend/common/validateUuid.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { redirectWindow } from '#pplx/frontend/platform-components/redirectWindow.js';
import { useParams } from '#pplx/frontend/router/useParams.js';
import { useEffect } from 'react';
const SwitchyardContent = Dynamic(async () => {
    const { SwitchyardContent } = await import('#pplx/frontend/apps/ask/restricted-feature-marble/SwitchyardContent.js');
    return { default: SwitchyardContent };
}, { restricted: true });
export function SwitchyardRoute() {
    const { uuid } = useParams();
    const { status } = useSession();
    const enabled = useMarbleEnabled({ defaultValue: false });
    useEffect(() => {
        if (!validateUuid(uuid) || status !== 'unauthenticated')
            return;
        // Sign-in is outside this SPA; preserve the full destination before the signed-in flag gate.
        redirectWindow(buildSignInRedirect(window.location.pathname, window.location.search + window.location.hash), 'Teammate session requires sign-in');
    }, [uuid, status]);
    if (!validateUuid(uuid))
        return _jsx(RedirectTo, { to: "/" });
    if (status !== 'authenticated')
        return null;
    if (!enabled)
        return _jsx(RedirectTo, { to: "/" });
    return _jsx(SwitchyardContent, { contextUUID: uuid });
}
//# sourceMappingURL=SwitchyardRoute.js.map